import { UseQueryResult } from '@tanstack/react-query'
import { useUserPoints } from '@/features/points/logic/seasonMew/useUserPoints'

export type Boosts = {
  hotStreakBoost: {
    active: boolean
    value: number
  }
}
export type UseBoostsResult = Pick<UseQueryResult<Boosts>, 'data' | 'isLoading' | 'error'>

export function getConsecutiveWeeksFromTiers(tiers?: Record<string, string>): number {
  if (!tiers) return 0
  const v = tiers['Weekly 100M Points Distribution']
  if (!v) return 0
  if (/new user/i.test(v)) return 0
  const n = v.match(/\d+/)?.[0]
  return n ? Number(n) : 0
}

export function useBoosts(): UseBoostsResult {
  const { data: userPoints, isLoading: userPointsLoading, error: userPointsError } = useUserPoints()

  const weeksActive = getConsecutiveWeeksFromTiers(userPoints?.tiers)

  return {
    isLoading: userPointsLoading,
    error: userPointsError,
    data: {
      hotStreakBoost: {
        active: weeksActive > 0,
        value: weeksActive,
      },
    },
  }
}
